import axios from 'axios'
import https from 'https'
import formatAuctionQueryUrl from '../functions/formatAuctionQueryUrl'

const getAuctionItems = async ({
  base,
  category,
  page,
  location,
  searchInput,
  pickupDate,
  condition,
}: {
  base: string
  category: string
  page: number
  location: number[] | number
  searchInput: string
  pickupDate: string[] | string
  condition: number[]
}) => {
  const isPast = base === 'past-auctions'
  const isMnr = base === 'mnr-auctions'
  const isPalletLot = category === 'pallet-lots'

  const instance = axios.create({
    httpsAgent: new https.Agent({
      rejectUnauthorized: false,
    }),
    baseURL: process.env.NEXT_PUBLIC_AUCTION_API,
  })

  const { url, query } = formatAuctionQueryUrl(base, category, page, {
    searchInput,
    pastAuction: isPast,
    isMnr,
    isPalletLot,
    location,
    pickupDate,
  })

  console.log('URL is .. ', url)

  const { data: auctionRequest } = await instance.get(url, {
    params: query,
    paramsSerializer: { indexes: null },
  })

  console.log('auction request dat is ', auctionRequest)

  const { url: getAuctionCountUrl, query: getAuctionCountQuery } =
    formatAuctionQueryUrl(
      base,
      category,
      page,
      {
        searchInput,
        pastAuction: isPast,
        isMnr,
        isPalletLot,
        location,
        pickupDate,
      },
      'getAuctionCount'
    )
  const { data: auctionCount } = await instance.get(getAuctionCountUrl, {
    params: getAuctionCountQuery,
    paramsSerializer: { indexes: null },
  })

  return { auctionRequest, auctionCount }
}

export default getAuctionItems
